import React from "react";
import { HiExclamationTriangle } from "react-icons/hi2";

interface DeactivateConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  name?: string;
  email?: string;
  onConfirm: () => void;
  loading?: boolean;
}

const DeactivateConfirmationModal: React.FC<DeactivateConfirmationModalProps> = ({ 
  show, 
  onClose, 
  name, 
  email, 
  onConfirm, 
  loading 
}) => {
  if (!show) return null;

  return (
    <div style={{ zIndex: 99999 }} className="fixed inset-0 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 dark:bg-black/70 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6 mx-4 max-w-md w-full transform transition-all">
        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-amber-100 dark:bg-amber-900/30 rounded-full">
          <HiExclamationTriangle className="w-6 h-6 text-amber-600 dark:text-amber-400" />
        </div>

        <p className="text-sm text-gray-900 dark:text-gray-100 text-center mb-4">
          <span className="font-medium text-base">Are you sure you want to deactivate</span>
          {name || email ? (
            <>
              <span className="block mt-1">
                <span className="font-semibold">{name}</span>
                {email && (
                  <span className="ml-1 px-2 py-0.5 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-mono text-xs align-middle">
                    {email}
                  </span>
                )}
                <span className="font-medium ml-1">?</span>
              </span>
            </>
          ) : (
            " this person?"
          )}
        </p>

        <p className="text-sm text-gray-600 dark:text-gray-300 text-center mb-5">
          Login access will be removed and this person won't be suggested for new tasks. Existing assignments will remain visible.
        </p>

        <div className="flex justify-center gap-2">
          <button
            onClick={onClose}
            disabled={!!loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 dark:focus:ring-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!!loading}
            className="px-4 py-2 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 dark:focus:ring-amber-400 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Deactivating…' : 'Deactivate user'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateConfirmationModal;

